<template>
  <div>
    <navbar :isAgent="true">
      <template v-slot:actionButton>
        <div class="buttons">
          <b-button rounded outlined class="is-info" @click="$router.push({name:'agentSignin'})">Sign In</b-button>
        </div>
      </template>
    </navbar>


    <div class="container" style="margin-top: 5%">

      <div class="columns" style="height: 600px">

        <div class="column">
          <div class="box ml-5" style="width: 150%; height: 100%">
            <img :src="require('@/assets/gifs/animation_640_l58gh1e8.gif')" alt="signup-gif" style="height: 550px;" align="left">
          </div>
        </div>

        <div class="column">
          <div class="box-1" style="height: 105%; margin-top: -2%" id="box1">
              <p class="signIn is-size-1">Sign Up</p>

             <div style="width: 90%; height: 500px; overflow-y: scroll;overflow-x: hidden; padding: 10px">
               <div class="mt-3">
                 <b-field
                     :type="invalidName == '' ? 'is-info' : 'is-danger'"
                     :message="invalidName"
                     label="Enter Your Name"
                     style="font-size: 100px; color: #e50909;text-align: left"
                     :label-position="labelPosition"
                 >
                   <b-input
                       type="text"
                       v-model="formdata.name"
                       placeholder="Jason carter"
                       rounded
                       @input="resetInvalidStatus('invalidName')">
                   </b-input>
                 </b-field>
               </div>

               <div class="mt-5">
                 <b-field
                     :type="invalidBranch == '' ? 'is-info' : 'is-danger'"
                     :message="invalidBranch"
                     style="font-size: 100px; color: #e50909;text-align: left"
                     label="Select Contact Number or Email"
                     :label-position="labelPosition">

                   <b-select placeholder="Contact Number or Email" rounded expanded  v-model="selectedContact" @input="resetInvalidStatus('invalidBranch');showContactType(selectedContact)">
                     <option
                         v-for="contact in contactTypes"
                         :value="contact.id"
                         :key="contact.id">
                       {{contact.Name}}
                     </option>
                   </b-select>
                 </b-field>
               </div>

               <div class="mt-5" v-if="showEmail">
                 <b-field
                     :type="invalidEmail == '' ? 'is-info' : 'is-danger'"
                     :message="invalidEmail"
                     label="Enter Your Email"
                     style="font-size: 100px; color: #e50909;text-align: left"
                     :label-position="labelPosition"
                 >
                   <b-input
                       type="email"
                       v-model="formdata.email"
                       placeholder="Jasoncarter@gmail.com"
                       rounded
                       @input="resetInvalidStatus('invalidEmail')"
                   ></b-input>
                 </b-field>
               </div>

               <div class="mt-5" v-if="showContact">
                 <b-field
                     :type="invalidContact == '' ? 'is-info' : 'is-danger'"
                     :message="invalidContact"
                     label="Enter Your Contact Number"
                     style="font-size: 100px; color: #e50909;text-align: left"
                     :label-position="labelPosition"
                 >
                   <b-input
                       type="text"
                       v-model="formdata.contact"
                       placeholder="0715904735"
                       rounded
                       @input="resetInvalidStatus('invalidContact')"
                   ></b-input>
                 </b-field>
               </div>

               <div class="columns mt-3">
                 <div class="column">
                   <b-field
                       style="font-size: 100px; color: #0d5da3;"
                       label="Select Your ID Type"
                       type="is-info"
                       :label-position="labelPosition">

                     <b-select placeholder="Select a type" rounded expanded @input="showElement"  v-model="selected">
                       <option
                           v-for="option in idType"
                           :value="option.id"
                           :key="option.id">
                         {{option.Value}}
                       </option>
                     </b-select>
                   </b-field>
                 </div>

                 <div class="column">
                   <b-field
                       v-if="showNic"
                       :type="invalidNIC == '' ? 'is-info' : 'is-danger'"
                       :message="invalidNIC"
                       label="Enter Your NIC Number"
                       style="font-size: 100px; color: #e50909;text-align: left"
                       :label-position="labelPosition"
                   >
                     <b-input
                         type="text"
                         v-model="formdata.NIC"
                         placeholder="972345678v"
                         rounded
                         @input="resetInvalidStatus('invalidNIC')"
                     ></b-input>
                   </b-field>

                   <b-field
                       v-if="showPassport"
                       :type="invalidPassport == '' ? 'is-info' : 'is-danger'"
                       :message="invalidPassport"
                       label="Enter Your Passport"
                       style="font-size: 100px; color: #e50909;text-align: left"
                       :label-position="labelPosition"
                   >
                     <b-input
                         type="text"
                         v-model="formdata.passport"
                         placeholder="N8494189"
                         rounded
                         @input="resetInvalidStatus('invalidPassport')"
                     ></b-input>
                   </b-field>
                 </div>
               </div>

<!--               <div class="mt-3">-->
<!--                 <b-field-->
<!--                     label="Select Your Department"-->
<!--                     :type="invalidDepartment == '' ? 'is-info' : 'is-danger'"-->
<!--                     :message="invalidDepartment"-->
<!--                     style="font-size: 100px; color: #e50909;text-align: left"-->
<!--                     :label-position="labelPosition"-->
<!--                 >-->
<!--                   <b-select placeholder="Select a department" rounded expanded v-model="formdata.department"  @input="resetInvalidStatus('invalidDepartment')">-->
<!--                     <option-->
<!--                         v-for="option in departments"-->
<!--                         :value="option.id"-->
<!--                         :key="option.id">-->
<!--                       {{option.Name}}-->
<!--                     </option>-->
<!--                   </b-select>-->
<!--                 </b-field>-->
<!--               </div>-->

<!--               <div class="columns mt-3">-->
<!--                 <div class="column">-->
<!--                   <b-field-->
<!--                       :type="invalidBranch == '' ? 'is-info' : 'is-danger'"-->
<!--                       :message="invalidBranch"-->
<!--                       style="font-size: 100px; color: #e50909;text-align: left"-->
<!--                       label="Select Your Branch"-->
<!--                       :label-position="labelPosition">-->

<!--                     <b-select placeholder="Select a branch" rounded expanded v-model="formdata.branch" @input="resetInvalidStatus('invalidBranch')">-->
<!--                       <option-->
<!--                           v-for="option in branches"-->
<!--                           :value="option.id"-->
<!--                           :key="option.id">-->
<!--                         {{option.Name}}-->
<!--                       </option>-->
<!--                     </b-select>-->
<!--                   </b-field>-->
<!--                 </div>-->

<!--                 <div class="column">-->
<!--                   <b-field-->
<!--                       :type="invalidDivision == '' ? 'is-info' : 'is-danger'"-->
<!--                       :message="invalidDivision"-->
<!--                       style="font-size: 100px; color: #e50909;text-align: left"-->
<!--                       label="Select Your Division"-->
<!--                       :label-position="labelPosition">-->

<!--                     <b-select placeholder="Select a division" rounded expanded v-model="formdata.division" @input="resetInvalidStatus('invalidDivision')">-->
<!--                       <option-->
<!--                           v-for="option in divisions"-->
<!--                           :value="option.id"-->
<!--                           :key="option.id">-->
<!--                         {{option.Name}}-->
<!--                       </option>-->
<!--                     </b-select>-->
<!--                   </b-field>-->
<!--                 </div>-->
<!--               </div>-->


               <div class="mt-5">
                 <b-field
                     :type="invalidPassword == '' ? 'is-info' : 'is-danger'"
                     :message="invalidPassword"
                     style="font-size: 100px; color: #e50909;text-align: left"
                     label="Enter Your Password"
                     :label-position="labelPosition"
                 >
                   <b-input
                       type="password"
                       v-model="formdata.password"
                       placeholder="*********"
                       rounded
                       password-reveal
                       @input="resetInvalidStatus('invalidPassword')"
                   ></b-input>
                 </b-field>
               </div>

               <div class="mt-5">
                 <b-field
                     :type="invalidConfirmPassword == '' ? 'is-info' : 'is-danger'"
                     :message="invalidConfirmPassword"
                     style="font-size: 100px; color: #e50909;text-align: left"
                     label="Re-Enter Your Password"
                     :label-position="labelPosition"
                 >
                   <b-input
                       type="password"
                       v-model="formdata.confirmPassword"
                       placeholder="*********"
                       rounded
                       password-reveal
                       @input="resetInvalidStatus('invalidConfirmPassword')"
                   ></b-input>
                 </b-field>
               </div>

               <br />

               <div class="mt-3" style="padding-bottom: 30px">
                 <div class="buttons">
                   <b-button type="is-info" @click="validateAndSubmit" :loading="formIsSubmitting" outlined rounded expanded>Sign Up</b-button>
                 </div>
               </div>

               <p>
                 Already have an account? <router-link :to="{name:'agentSignin'}">Sign In</router-link>
               </p>
              </div>

          </div>
        </div>

      </div>
    </div>
  </div>



</template>

<script>
import axios from 'axios'
import Navbar from '@/components/common/Navbar'
export default {
  name:"signUp-view",

  components:{
    Navbar
  },

  data(){
    return{
      labelPosition: "on-border",
      formdata:{
        name:'',
        email:'',
        contact:'',
        NIC:'',
        passport:'',
        department:null,
        password: '',
        confirmPassword:'',
        branch:null,
        division:null,

      },

      formIsInvalid: false,
      invalidName: '',
      invalidEmail: '',
      invalidContact: '',
      invalidRole: '',
      invalidPassword: '',
      invalidNIC:'',
      invalidPassport:'',
      invalidBranch:'',
      invalidDepartment:'',
      invalidDivision:'',
      invalidConfirmPassword:'',

      departments:[{id:'1',Name:'department 1'},{id:'2',Name:'department 2'}],
      branches:[{id:'1',Name:'branch 1'},{id:'2',Name:'branch 2'}],
      divisions:[{id:'1',Name:'division 1'},{id:'2',Name:'division 2'}],

      idType:[{id:'1',Value:'NIC'},{id:2,Value:'Passport'}],
      contactTypes:[
        {id:'1',Name:'Contact Number'},
        {id:'2',Name:'Email'},
      ],
      showNic:true,
      showPassport:false,
      selected:1,
      selectedContact:1,

      showContact:false,
      showEmail:false,

      regex:{
        name: /^[a-zA-Z][a-zA-Z ]+$/,
        password:/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        last_name: /^[a-zA-Z][a-zA-Z ]+$/,
        userName: /^[a-zA-Z0-9._]+$/,
        contact:/^(?:0|94|\+94)7(0|1|2|4|5|6|7|8)\d\d{6}$/,
        // nic:/^([0-9]{9}[Xx||Vv])$/,
        nic:/^([0-9]{9}[x|X|v|V]|[0-9]{12})$/,
        oldNIC:/^([0-9]{9}[Xx||Vv])$/,
        passport: /^[0-9A-Za-z]{4,18}$/,
        email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      },


      formIsSubmitting: false
    }
  },

  mounted() {
    if(this.selectedContact == 1){
      this.showContact = true
      this.showEmail = false
    }else{
      this.showEmail = true
      this.showContact = false
    }
  },

  methods:{
    showElement:function (value){

      if(value == 1){
        this.showNic = true
        this.showPassport=false
      }else{
        this.showNic = false
        this.showPassport = true
      }
    },

    showContactType:function (value){
      console.log(value)
      if(value == 1){
        this.showContact = true
        this.showEmail = false
      }else{
        this.showEmail = true
        this.showContact = false
      }
    },

    validateForm: function(){
      var formIsValid = true

      if(this.showNic == true){
        // Return today's date and time
        var currentTime = new Date()
        var year = currentTime.getFullYear()
        var age

        //nic
        if(this.formdata.NIC =='' || this.formdata.NIC.indexOf(' ') >= 0){
          this.invalidNIC = 'NIC cannot be empty'
          formIsValid = false
        }
        else if(!this.regex.nic.test(this.formdata.NIC)){
          this.invalidNIC = 'Please enter valid NIC'
          formIsValid = false
        }else{
          //check old nic
          if(this.formdata.NIC.length == 10){
            console.log('old nic')
            var digits = this.formdata.NIC.substring(0,2)
            const BirthYear = Number("19"+digits);
            age  = year-BirthYear;
            if(age > 80){
              this.invalidNIC = 'Please enter valid NIC'
              formIsValid = false
            }

          }else if(this.formdata.NIC.length == 12){  //check new nic
            var fourdigits = this.formdata.NIC.substring(0,4)
            age  = year-fourdigits;
            if(age > 80){
              this.invalidNIC = 'Please enter valid NIC'
              formIsValid = false
            }
          }
        }

      }else{
        //passport
        if(this.formdata.passport =='' || this.formdata.passport.indexOf(' ') >= 0) {
          this.invalidPassport = 'Passport number cannot be empty'
          formIsValid = false
        }
        if(this.regex.oldNIC.test(this.formdata.passport)){
          this.invalidPassport = 'Invalid passport number'
          formIsValid = false
        }
      }
      // first name
      if(this.formdata.name =='' ){
        this.invalidName = 'Name cannot be empty'
        formIsValid = false
      }
      else if(!this.regex.name.test(this.formdata.name)){
        this.invalidName = 'Name cannot contain numbers or special characters'
        formIsValid = false
      }

      if(this.selectedContact == 1){
        //contact number
        if(this.formdata.contact =='' || this.formdata.contact.indexOf(' ') >= 0){
          this.invalidContact = 'Contact number cannot be empty'
          formIsValid = false
        }
        else if(!this.regex.contact.test(this.formdata.contact)){
          this.invalidContact = 'Please enter valid contact number'
          formIsValid = false
        }
      }else{
        // email
        if(this.formdata.email =='' || this.formdata.email.indexOf(' ') >= 0){
          this.invalidEmail = 'Email cannot be empty'
          formIsValid = false
        }
        else if(!this.regex.email.test(this.formdata.email)){
          this.invalidEmail = 'Please enter valid email address'
          formIsValid = false
        }
      }



      // //branch
      // if(this.formdata.branch ==null){
      //   this.invalidBranch = 'Branch cannot be empty'
      //   formIsValid = false
      // }
      //
      // //department
      // if(this.formdata.department ==null){
      //   this.invalidDepartment = 'Department cannot be empty'
      //   formIsValid = false
      // }
      //
      // //division
      // if(this.formdata.division ==null){
      //   this.invalidDivision = 'Division cannot be empty'
      //   formIsValid = false
      // }

      //password
      if(this.formdata.password =='' || this.formdata.password.indexOf(' ') >= 0){
        this.invalidPassword = 'Password cannot be empty'
        formIsValid = false
      }else if(this.formdata.password.length < 8){
        this.invalidPassword = 'Password must be at least 8 characters'
        formIsValid = false
      }else if(this.formdata.password.length > 20){
        this.invalidPassword = 'Password must be 8 - 20 characters'
        formIsValid = false
      }else if(!this.regex.password.test(this.formdata.password)){
        this.invalidPassword = 'Password must be contain at least one letter, one number and one special character'
        formIsValid = false
      }

      //confirm password
      if(this.formdata.confirmPassword =='' || this.formdata.confirmPassword.indexOf(' ') >= 0){
        this.invalidConfirmPassword = 'Re-Enter Password cannot be empty'
        formIsValid = false
      }else if(this.formdata.password != this.formdata.confirmPassword) {
        this.invalidConfirmPassword = 'Passwords do not match'
        formIsValid = false
      }



      if(formIsValid){
        return true
      }
      else{
        return false
      }

    },

    submitForm:function (){
      var component = this
      var type=''
      var idNumber=''
      component.formIsSubmitting =true

      if(component.showNic == true){
         type = 'NIC'
          idNumber = component.formdata.NIC
      }else{
         type = 'Passport'
         idNumber = component.formdata.passport
      }


      axios.post(component.$base_url+'/agent/register', {
        name:component.formdata.name,
        email:component.formdata.email,
        contact_number:component.formdata.contact,
        id_type:type,
        // department:component.formdata.department,
        // branch:component.formdata.branch,
        // division: component.formdata.division,
        password: component.formdata.password,
        id_number:idNumber

      })
          .then(function (data) {
            var array =[]
            array = data.data
            console.log(array.data.message)
            if(array.success == true){
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-success'
              })
              component.formIsSubmitting =false
              component.$router.push({name:'agentSignin'})
            }else{
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-danger'
              })
              component.formIsSubmitting=false
            }

          })
          .catch(function (error) {
            console.log(error)
          });
    },

    resetInvalidStatus: function(key){

      this[key] = ''
      this.formIsInvalid = false


    },

    validateAndSubmit: function(){
      if(this.validateForm()){
        this.submitForm()
      }
      else{
        this.formIsInvalid = true
      }
    },
  }
}
</script>

<style scoped>
@media only screen and (max-width: 600px) {
.box{
  display: none;
}

.box-1{
  z-index: 0;
  border-radius: 0;
  box-shadow: none;
}

}



.signIn {
  padding-top: 30px;
  font-weight: bold;
  background: -webkit-linear-gradient(#3a8fff 0 30%, #0837ae 55% 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

p {
  color: gray;
  font-weight: 500;
}
.link {
  color: #0d5da3;
  text-decoration: underline;
  cursor: pointer;
}
.link:hover {
  color: #092bc2;
  text-shadow: 1px;
}

.box-1 {
  position: relative;
  z-index: 1;
  background-color: white;
  border-radius: 0 15px 15px 0;
  box-shadow: 0 -5px 5px -5px #333, 5px 0 5px -5px #333, 0 5px 5px -5px #333;

}
.box-1::before {
  position: absolute;
  left: -5%;
  content: "";
  width: 70px;
  z-index: -1;
  height: 100%;
  background-color: inherit;
  border-radius: 15px 0 0 15px;
  box-shadow: 0 -1px 5px -5px #333, -5px 0 5px -5px #333, 1px 5px 0px -5px #333;
  /* box-shadow: 0px 10px 0px 0 rgb(41, 33, 33); */
  transform: skew(-5deg);

}



</style>
